<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [{"num_cand":"U2FsdGVkX1+qhk7BcIXBeWIdSVfYerJY8yCVe9J28dY=","cpf":"U2FsdGVkX19fYiCGgIoCJD6FzGLz+ZM83wlOedguCXM="},{"num_cand":"U2FsdGVkX19ko6wilh6V1aP/+O+wpv766waUOXng4Nw=","cpf":"U2FsdGVkX1/ok4MCklE5rVUUgVj5EDrGXqz88MwLy1I="},{"num_cand":"U2FsdGVkX18UkeJujjMiL38z0bTYA5Eb9BqY2FjMZkY=","cpf":"U2FsdGVkX18pVDC5re/0Q+rILpGxPm03ST78wP7H97o="},{"num_cand":"U2FsdGVkX19umW9SYdBekukblSk5xEx+hQCOh6KL3gM=","cpf":"U2FsdGVkX1+roKW+5jhaDFNc3lDDjvVvaIi4jT6G6B4="},{"num_cand":"U2FsdGVkX1/ctdJrQqvMwMs3AeMeQnMg+DvAVtKmCpc=","cpf":"U2FsdGVkX1/m0wLcTRulTeSk+roebRu1sqN+wK5NS7k="},{"num_cand":"U2FsdGVkX19Q604d0v6BjmKezTCUakdLfjEcuz3S19M=","cpf":"U2FsdGVkX196UU+2vcDGFdA7yDbOjbsF00aGEtLDOCY="},{"num_cand":"U2FsdGVkX1/yrYvab4zIsCCX+2KxS6fKcJmMzjkq0Vc=","cpf":"U2FsdGVkX19oYe7Z0b3irF74r94YxOYN2AvvQUgZA9Q="},{"num_cand":"U2FsdGVkX18O6nM8lraZRgYZwCO6TJIAJOtqV3GAGKY=","cpf":"U2FsdGVkX1+IY5bk7Nw8tRw2fGDefR1bHxi1V8jh3Vg="},{"num_cand":"U2FsdGVkX18Fd0hbJi2hOn466N8nIiWpmvmCYRIoHOM=","cpf":"U2FsdGVkX19zE2JsIzOlzN3fn3e72+DngX861B9pKVs="},{"num_cand":"U2FsdGVkX19g2jN8d2lJInR2im8WBHE4VMSq4VerUJ8=","cpf":"U2FsdGVkX193QMMNsMv51vgHn0M7IF40AS0bPkwMBL4="},{"num_cand":"U2FsdGVkX1/GypTlVrteHUstw85xn+FIw6eE5WG7480=","cpf":"U2FsdGVkX1/AjZj8CFDWQIig2t3TSwdLMxf+IH4c5NE="},{"num_cand":"U2FsdGVkX1/DjXDBFlkeoFrzaeghFt5w8f+pq2SuIWc=","cpf":"U2FsdGVkX18DX8TE25P2hudYNlQIp6kVftaN4c2XUio="},{"num_cand":"U2FsdGVkX19cNBOR/ijCOWyS/eDYdDgxbcibMLRJpgA=","cpf":"U2FsdGVkX1/XZ3CMndu4ydKZcFQcHB1JhAEj5CpdmTA="},{"num_cand":"U2FsdGVkX18hoekKZ/EWNCDUM+KsyOb9JXqvPDFE+aI=","cpf":"U2FsdGVkX18nxFctyLTyyTPE87P1DJRHsKJTBgkLCxQ="},{"num_cand":"U2FsdGVkX1/sL++SptWNkDCQ4grZqI4l5FpxqncFfz8=","cpf":"U2FsdGVkX1/1FVEYH2bdH2TbQ6MnWMX4/Gw2rHBJ6T4="},{"num_cand":"U2FsdGVkX19ApP2McAys/kus+23mCxYEsP6Cwmh6N9w=","cpf":"U2FsdGVkX1+H7Ng5+mp87IgCjtmS+nBsfDoRQFUfMy0="},{"num_cand":"U2FsdGVkX18cCoLwB4t6K2Ube9hAtyl6OLElxq0sV6g=","cpf":"U2FsdGVkX1+sk9MAnFfQwlP1gY/BbkvEY+9VUqK9PlA="},{"num_cand":"U2FsdGVkX1/6nQCWiiueqfx5+Zetj5kaYCV7Iev/ouE=","cpf":"U2FsdGVkX192JUHuQkOFOLmmlPpL/lxlvUo616KXlvU="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2201/2201_rec_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
